
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

// styles for this kit
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.5.0";
import "assets/demo/demo.css?v=1.5.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.5.0";
// pages for this kit
import Index from "views/Index.js";
import NucleoIcons from "views/NucleoIcons.js";
import LoginPage from "views/examples/LoginPage.js";
import LandingPage from "views/examples/LandingPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import AboutUs from "views/AboutUs.js";
import GstServices from "views/services/GstServices.js";
import Auditing from "views/services/Auditing";
import Business from "views/services/Business";
import IncomeTax from "views/services/IncomeTax";
import ContactUs from "views/ContactUs";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      <Switch>
        <Route path="/index" render={(props) => <Index {...props} />} />
        <Route
          path="/nucleo-icons"
          render={(props) => <NucleoIcons {...props} />}
        />
        {/* <Route
          path="/landing-page"
          render={(props) => <LandingPage {...props} />}
        />
        <Route
          path="/profile-page"
          render={(props) => <ProfilePage {...props} />}
        /> */}
        <Route
          path="/login-page"
          render={(props) => <LoginPage {...props} />}
        />
        <Route
          path="/aboutus"
          render={(props) => <AboutUs {...props} />}
        />
        <Route
          path="/contactus"
          render={(props) => <ContactUs {...props} />}
        />
        <Route
          path="/gst-service"
          render={(props) => <GstServices {...props} />}
        />
        <Route
          path="/auditing-service"
          render={(props) => <Auditing {...props} />}
        />
        <Route
          path="/business-service"
          render={(props) => <Business {...props} />}
        />
        <Route
          path="/tax-service"
          render={(props) => <IncomeTax {...props} />}
        />
       
        <Redirect to="/index" />
        <Redirect from="/" to="/index" />
      </Switch>
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);
